import { useState } from 'react';
import type React from 'react';
import FormInput from '../../components/forms/input';
import { useToast } from '../../components/toast';

export interface ChangePasswordCardProps {
    onSubmit: (data: { oldPassword: string; newPassword: string; confirmPassword: string }) => Promise<void>;
}

export default function ChangePasswordCard({ onSubmit }: ChangePasswordCardProps) {
    const toast = useToast();
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (newPassword !== confirmPassword) {
            toast.error('Passwords do not match');
            return;
        }
        setLoading(true);
        try {
            await onSubmit({ oldPassword, newPassword, confirmPassword });
            toast.success('Password changed successfully');
            setOldPassword('');
            setNewPassword('');
            setConfirmPassword('');
        } catch (err) {
            toast.error(err instanceof Error ? err.message : 'Failed to change password');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="rounded-xl border border-[#eee] bg-white p-6">
            <div className="mb-6 rounded-lg bg-[#FFF4EC] px-4 py-3">
                <p className="text-[14px] font-semibold text-primary">Ensure that these requirements are met</p>
                <p className="mt-1 text-[13px] text-primary/80">Minimum 8 characters long, uppercase &amp; symbol</p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-5">
                <FormInput
                    title="Old Password"
                    id="old-password"
                    type="password"
                    placeholder="••••••••••"
                    value={oldPassword}
                    onChange={(e) => setOldPassword(e.target.value)}
                    variant="white"
                />
                <FormInput
                    title="New Password"
                    id="new-password"
                    type="password"
                    placeholder="••••••••••"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    variant="white"
                />
                <FormInput
                    title="Confirm New Password"
                    id="confirm-password"
                    type="password"
                    placeholder="••••••••••"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    variant="white"
                />

                <div className="flex justify-end">
                    <button
                        type="submit"
                        disabled={loading}
                        className="rounded-lg bg-secondary px-8 py-2.5 text-[14px] font-semibold text-white transition-colors hover:bg-secondary-400 disabled:opacity-50"
                    >
                        {loading ? 'Changing...' : 'Change Password'}
                    </button>
                </div>
            </form>
        </div>
    );
}
